import { appData } from '@/mocks/movies';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10 lg:p-14">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 font-medium mb-4">
                {appData.tagline}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5 max-w-lg mx-auto lg:mx-0">
                {appData.desc}
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6">
                {appData.features.map((f) => (
                  <span
                    key={f}
                    className="px-3 py-1.5 bg-background-50 border border-background-200/70 text-xs md:text-sm text-foreground-700 rounded-full whitespace-nowrap"
                  >
                    {f}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-7 py-3 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center flex items-center justify-center gap-2"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store
                </a>
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-7 py-3 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center flex items-center justify-center gap-2"
                >
                  <i className="ri-android-fill text-lg"></i>
                  Android 版
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-48 md:w-56 h-48 md:h-56 rounded-2xl bg-background-200 flex items-center justify-center border border-background-300/60">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl md:text-6xl text-foreground-400"></i>
                  <p className="text-xs text-foreground-500 mt-2">被窝影院 APP</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}